import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';

/**
 * Enhanced Handle component with improved usability
 *
 * @param {Object} props - Component props
 * @param {string} props.type - Handle type ('source' or 'target')
 * @param {Position} props.position - Handle position
 * @param {string} props.id - Handle ID
 * @param {Object} props.style - Handle style
 * @param {boolean} props.isConnectable - Whether handle is connectable
 * @param {string} props.color - Base color for the handle
 * @returns {JSX.Element} - Enhanced handle component
 */
const EnhancedHandle = ({
                            type,
                            position,
                            id,
                            style = {},
                            isConnectable,
                            color = '#1890ff'
                        }) => {
    const [isHovering, setIsHovering] = useState(false);

    // Base style for the visible handle
    const handleStyle = {
        width: isHovering ? 16 : 12,
        height: isHovering ? 16 : 12,
        backgroundColor: color,
        border: '2px solid white',
        transition: 'all 0.2s ease',
        zIndex: 10,
        ...style
    };

    // Add box shadow only when hovering
    if (isHovering) {
        handleStyle.boxShadow = `0 0 0 6px ${color}30`;

        // Adjust position to account for size change during hover
        if (style.top !== undefined) {
            handleStyle.top = parseFloat(style.top) - 2;
        }
        if (style.bottom !== undefined) {
            handleStyle.bottom = parseFloat(style.bottom) - 2;
        }
        if (style.left !== undefined) {
            handleStyle.left = parseFloat(style.left) - 2;
        }
        if (style.right !== undefined) {
            handleStyle.right = parseFloat(style.right) - 2;
        }
    }

    return (
        <Handle
            type={type}
            position={position}
            id={id}
            style={handleStyle}
            isConnectable={isConnectable}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        />
    );
};

export default EnhancedHandle;
